module.exports = __webpack_public_path__ + "static/media/wizardRuinedSpell2.fb584fba.png";